import { Partial } from '@40seas/entities/common';
import { AirwallexTransfer } from './airwallex-transfer';

export class UpdateAirwallexTransferDto extends Partial(AirwallexTransfer) {}
